// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bolt-label-autocomplete {
  position: relative;
  min-width: 128px;
  min-height: 20px;
  flex-shrink: 0;
}
.bolt-label-autocomplete input {
  width: 100%;
  height: 100%;
  position: absolute;
  background-color: transparent;
  z-index: 2;
}
.bolt-label-autocomplete input::-ms-clear {
  display: none;
}
.bolt-label-autocomplete input.suggestion {
  color: rgba(0, 0, 0, .55);
  color: var(--text-secondary-color,rgba(0, 0, 0, .55));
  z-index: 1;
}

.bolt-label-suggestions-callout {
  border-radius: 4px;
}
.bolt-label-suggestions-callout .bolt-callout-content {
  width: 248px;
  border-radius: 4px;
}

.bolt-label-suggestions-container {
  padding: 8px 0px;
}
.bolt-label-suggestions-container .bolt-colorpip .bolt-colorpip-content {
  background-color: rgba( 239, 239, 239 ,  1 );
  background-color: rgba( var(--palette-neutral-6,239, 239, 239) ,  1 );
}
.bolt-label-suggestions-container .bolt-label-suggestions-row {
  height: 32px;
}
.bolt-label-suggestions-container .bolt-label-suggestions-row.selected {
  background-color: rgba( 222, 236, 249 ,  1 );
  background-color: rgba( var(--palette-primary-tint-30,222, 236, 249) ,  1 );
}
.bolt-label-suggestions-container .bolt-label-suggestions-row.clickable {
  cursor: pointer;
}
.bolt-label-suggestions-container .bolt-label-suggestions-row .bolt-label-suggestions-row--content {
  display: flex;
  flex: 1;
  min-width: 0px;
  height: 32px;
  align-items: center;
  font-size: 0.875rem;
}
.bolt-label-suggestions-container .bolt-label-suggestions-row .bolt-label-suggestions-row--content span {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.bolt-label-suggestions-container .bolt-label-suggestions-row .bolt-label-suggestions-icon {
  margin: 0px 8px;
  font-size: 1rem;
  display: flex;
  align-items: center;
}
.bolt-label-suggestions-container .bolt-suggestions-separator {
  height: 1px;
  margin: 7px 12px 8px;
  background-color: rgba( 218, 218, 218 ,  1 );
  background-color: rgba( var(--palette-neutral-10,218, 218, 218) ,  1 );
}
.bolt-label-suggestions-container .bolt-colorswatchpicker.selected {
  background-color: rgba( 222, 236, 249 ,  1 );
  background-color: rgba( var(--palette-primary-tint-30,222, 236, 249) ,  1 );
}
.bolt-label-suggestions-container .bolt-label-suggestions-list {
  max-height: 208px;
  overflow-y: auto;
}

/*# sourceMappingURL=Autocomplete.css.map */
`, "",{"version":3,"sources":["webpack://./../azure-devops-ui/src/Components/Autocomplete/Autocomplete.scss","webpack://./../azure-devops-ui/bin/Components/Autocomplete/Autocomplete.css","webpack://./../azure-devops-ui/src/Core/_platformCommon.scss"],"names":[],"mappings":"AACA;EACI,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;ACAJ;ADEI;EACI,WAAA;EACA,YAAA;EAEA,kBAAA;EACA,6BAAA;EACA,UAAA;ACDR;ADGQ;EACI,aAAA;ACDZ;ADIQ;EACI,yBE6IK;EF5IL,qDAAA;ECFV,UAAU;AACZ;;AAEA;EACE,kBAAkB;ADMhB;ACJJ;EDMQ,YAAA;ECJN,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;ADQV;ACNR;EACE,4CAA4C;EDU1C,qEAAA;ACRJ;AACA;EDUQ,YAAA;ACRR;AACA;EDWQ,4CAAA;EACI,2EAAA;ACTZ;ADYQ;EACI,eAAA;ACVZ;AACA;EDYY,aAAA;EACA,OAAA;EAEA,cE8MA;EDzNV,YAAY;EDaF,mBAAA;EACI,mBAAA;ACXhB;AACA;EACE,mBAAmB;EDeb,gBAAA;EACI,uBAAA;ACbZ;AACA;EDeY,eAAA;ECbV,eAAe;EDiBb,aAAA;EACI,mBAAA;ACfR;AACA;EACE,WAAW;EDkBT,oBAAA;EACI,4CElDgB;EDkCtB,sEAAsE;ADmBpE;ACjBJ;EDmBQ,4CAAA;ECjBN,2EAA2E;AAC7E;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,2CAA2C","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
